import { useState, useEffect } from 'react';
import type { Class } from '@engage/classes';
import type { PendingResult } from '@engage/result';
import { ok, pending } from '@engage/result';

/**
 * helper for useHasClassesWithoutLanguagePreference in @engage/schedule & @engage/library
 */
export const useEndpointReturnsClasses = (
  apiCall: () => Promise<{ classes: Class[] }>,
  shouldFetch = true,
) => {
  const [endpointReturnsClasses, setEndpointReturnsClasses] = useState<
    PendingResult<boolean, undefined>
  >(pending);

  useEffect(() => {
    // reset state in case we have been mounted for a while
    // and already made this request
    setEndpointReturnsClasses(pending);

    if (!shouldFetch) {
      return;
    }
    (async () => {
      try {
        const data = await apiCall();
        setEndpointReturnsClasses(ok(data.classes.length > 0));
      } catch {
        setEndpointReturnsClasses(ok(false));
      }
    })();
  }, [shouldFetch]);

  return endpointReturnsClasses;
};
